/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (root) {
'use strict';
function el(doc, tag, cls, text) { var e = doc.createElement(tag); e.className = cls; if (text !== undefined) e.textContent = text; return e; }
    function sprawdzWszystkie(doc, S, en) {
        var host = doc.getElementById('kupon');
        if (!host || doc.getElementById('sprawdz-wszystkie')) { return; }
        var panel = el(doc, 'section', 'karta'); panel.id = 'sprawdz-wszystkie';
        var button = el(doc, 'button', "przycisk przycisk--glowny", jst("sprawdz_wszystkie_js.25e0a6417c48"));
        button.type = 'button';
        var status = el(doc, 'p', 'podpowiedz'); status.setAttribute('role', 'status');
        var output = el(doc, 'div', 'grupa');
        panel.appendChild(button); panel.appendChild(status); panel.appendChild(output); host.appendChild(panel);
        button.addEventListener('click', function () {
            var saved = [];
            S.gry().forEach(function (kod) { S.lista(kod).forEach(function (z) { saved.push({ kod: kod, z: z }); }); });
            output.textContent = '';
            if (!saved.length) { status.textContent = jst("sprawdz_wszystkie_js.e0c01ff5c4ab"); return; }
            button.disabled = true;
            status.textContent = jst("sprawdz_wszystkie_js.508188a2a87e");
            root.fetch('/assets/json/db/index.json', { cache: 'no-cache', credentials: 'same-origin' })
                .then(function (r) { if (!r.ok) { throw new Error('http'); } return r.json(); })
                .then(function (data) {
                    if (!data || !Array.isArray(data.games)) { throw new Error('data'); }
                    var checked = 0;
                    saved.forEach(function (x) {
                        var g = data.games.filter(function (v) { return v.code === x.kod; })[0], r = S.reguly(x.kod);
                        var valid = g && Array.isArray(g.numbers) && g.numbers.length === r.pick && g.drawn_at && Number.isFinite(Date.parse(g.drawn_at)) && (!r.dodatkowe || (Array.isArray(g.special) && g.special.length === r.dodatkowe.ile)) && S.normalizuj(x.kod, g.numbers, r.dodatkowe ? g.special : []).ok;
                        var detail = el(doc, 'details', 'karta'); detail.open = saved.length === 1;
                        var result = valid ? S.porownaj(x.z, g.numbers, r.dodatkowe ? g.special : []) : null;
                        var label = r.nazwa + ' — ' + x.z.name + ': ';
                        label += result ? result.glowne + (jst("sprawdz_wszystkie_js.6e212d8b521b")) + x.z.numbers.length + (r.dodatkowe ? ' + ' + result.dodatkowe + (jst("sprawdz_wszystkie_js.6e212d8b521b")) + x.z.extra.length : '') : (jst("sprawdz_wszystkie_js.9e5bdfcf21c3"));
                        detail.appendChild(el(doc, 'summary', '', label));
                        if (valid) {
                            checked++;
                            detail.appendChild(el(doc, 'p', '', g.drawn_at.slice(0, 16).replace('T', ' ') + ((g.draw_system_id ?? g.legacy_id) ? ' · ' + (jst("sprawdz_wszystkie_js.cdf9f797907f")) + (g.draw_system_id ?? g.legacy_id) : '')));
                            detail.appendChild(root.PewniakiZestawy.kule(doc, en, x.kod, x.z, result));
                            detail.appendChild(el(doc, 'p', 'podpowiedz', jst("sprawdz_wszystkie_js.f146561fba93")));
                        }
                        output.appendChild(detail);
                    });
                    status.textContent = (jst("sprawdz_wszystkie_js.ab03a3494a68")) + checked + ' / ' + saved.length + (jst("sprawdz_wszystkie_js.cd0a6d6d4f5d"));
                    var seen = {};
                    saved.forEach(function (item) { if (!seen[item.kod]) { seen[item.kod] = true; S.zdarzenie('ticket_check_all', item.kod, 'sprawdzarka', S.lista(item.kod).length); } });
                }).catch(function () { output.textContent = ''; status.textContent = jst("sprawdz_wszystkie_js.1bb91d2d076a"); })
                .then(function () { button.disabled = false; });
        });
        if (root.location && root.location.hash === '#sprawdz-wszystkie') { button.click(); panel.scrollIntoView({ block: 'start' }); }
    }

root.PewniakiSprawdzWszystkie = sprawdzWszystkie;
})(window);
